import { render, staticRenderFns } from "./SpecialitiesGrid.vue?vue&type=template&id=33d43f66"
import script from "./SpecialitiesGrid.vue?vue&type=script&lang=js"
export * from "./SpecialitiesGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports